import apiClient from '../../../api/apiClient';
import { ADMIN_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = ADMIN_REST_API_BASE_URL;

export const getScheduleItemsByLoggedInUser = (appCode) =>
  apiClient.post(`${REST_API_BASE_URL}/schedule/items`, { appCode });
export const createSchedule = (scheduleData) =>
  apiClient.post(`${REST_API_BASE_URL}/schedule/create`, scheduleData);

// export const saveSubscriptionByMembership = (id, subscription) => apiClient.post(`${REST_API_BASE_URL}/membership/${id}/subscription`, subscription);
// export const addProductBySubscription = (subid, prodid) => apiClient.post(`${REST_API_BASE_URL}/subscription/${subid}/product/${prodid}`);

export default apiClient;
